import * as Yup from "yup";

import { Button, Card, Col, Dropdown, Row } from "@themesberg/react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  faBoxOpen,
  faChevronDown,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import {
  getProductionDetailsForGetData,
  postProduction,
} from "../../Service/AllProductionAPI";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Rolling from "../../assets/img/Rolling.gif";
import Select from "react-select";
import Swal from "sweetalert2";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { getCustomerList } from "../master/AllUserDropDown";
import moment from "moment-timezone";
import { selectProducttype } from "../SelectOption";
import { selectcustomer } from "../SelectOption";
import swal from "sweetalert";

/* ----- declaration of validationSchema validation (based on the object schema provided by Yup) and
  display of validation errors ----- */
const validationSchema = Yup.object({
  customerName: Yup.string().required("Required *"),
  productType: Yup.string().required("Required *"),
  workOrderNo: Yup.string()
    .required("Required *")
    .matches(/^[0-9\s]*$/, "Enter Numbers Only"),
 
});

export default () => {
  const [show, setShow] = useState(false);
  const [customerName, setCustomerName] = useState([]);
  // const [productionList, setProductionList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [csd, setCsd] = useState([1]);
  const [mre, setMre] = useState([1]);
  const [lkd, setLkd] = useState([1]);

// newly added board vr and printer
  const [pvr, setPvr] = useState([1]);
  const [prn, setPrn] = useState([1]);
// calibration disable button after success msg
const [IsProduction,setIsProduction]=useState (false)
  const [isLoaded, setisLoaded] = useState(false);
  const token = sessionStorage.getItem("token");
  // const [processNum, setProcessNum] = useState("");
  const [processData, setProcessData] = useState([]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    // ----- Function call to get customers, Dealers and  Service Engineers list
    getCustomersList();
    // getProductionList();
    alertMessage();
  }, []);

  // ----- Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  const processNum = sessionStorage.getItem("pkUserId");

  const alertMessage = () => {
    Swal.fire({
      position: "top-center",
      title: "Please read the data using RS485 to generate dispenser serial number ...",
      showConfirmButton: false,
      timer: 3000,
    });
  };

  // Dispenser data Filter by model name

// Added new boards in modelQty (prn and pvr)  with other boards (csd,mre,lkd) and (Mcu,Tot)
  const modelQty = [
    {
      modelNo: "1111",
      csd: [1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },

       {
      modelNo: "1122",
      csd: [1,1],
      mre: [1],
      lkd: [1,1],
      prn: [1],
      pvr: [1],
    },
         {
      modelNo: "1244",
      csd: [1,1,1,1],
      mre: [1,1],
      lkd: [1,1,1,1],
      prn: [1,1],
      pvr: [1],
    },

          {
      modelNo: "2244",
      csd: [1,1,1,1],
      mre: [1,1],
      lkd: [1,1,1,1],
      prn: [1,1],
      pvr: [1],
    },
    {
      modelNo: "1121",
      csd: [1, 1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2422",
      csd: [1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3622",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4822",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3644",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4844",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
  ];

  return (
    // ----- Formik provides the Form, Field and ErrorMessage
    <Formik
      initialValues={{
        customerName: "",
        workOrderNo: "",
        productType: "",
        // processNumber: "",  // removed for new BT version
      }}
      validationSchema={validationSchema}

      onSubmit={async (values, { resetForm }) => {
        try {
          setisLoaded(true);
          const data = {
            workOrderNo: values.workOrderNo,
            customerName: values.customerName,
            fkCustomerId: selectedCustomer,
            productType: values.productType,
            // processNumber: values.processNumber,  // removed for new BT version
          };
          // console.log("Production Data", data);
          const headers = { Authorization: `Bearer ${token}` };
          const result = await postProduction(data, headers);

          // console.log("Add Production", result);

          if (result.data.message === "Process Number alrady Present") {
            setisLoaded(false);
            swal("Failed", "Process Number already Present", "error");
          } else if (result.data.message === "wrong CustomerName Entered") {
            setisLoaded(false);
            swal("Failed", "Wrong Customer Name Entered", "error");
          } else if (result.data.message === "wrong ProductType Entered") {
            setisLoaded(false);
            swal("Failed", "Wrong Product Type Entered", "error");
          } else if (result.data.message === "BordScerial Number Not Present In PKI") {
            setisLoaded(false);
            swal("Failed", "BordSerial Number Not Present In PKI", "error");
          } else if (result.data.message === "dispenser data is not scaned for this work order addproductiondetails 1") {
            setisLoaded(false);
            swal("Failed", "Dispenser data is not scanned for this work order", "error");
          } else if (result.data.message === "PKI Server is down..") {
            setisLoaded(false);
            swal("Failed", "PKI Server is down", "error");
          } else if (result.data.message === "dispenser data is not scaned for this work order addproductiondetails 2") {
            setisLoaded(false);
            swal("Failed", "dispenser data is not scaned for this work order addproductiondetails 2", "error");
          } else if (result.data.message === "production added successfully") {
            setisLoaded(false);
            // setTimeout(() => {
            //   window.location.href = "production/production-list";
            // }, 7000);
            const token = sessionStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };
            getProductionDetailsForGetData(processNum, headers)
              .then((result) => {
                // console.log("getProductionDetailsForGetData result :-", result);
                if (result.data) {
                  setProcessData(result.data);
                  setShow(true);
                  let selectedModule = modelQty.filter((obj) => {
                    return obj.modelNo === result.data.modelName;
                  });
                  // console.log("selectedModule :-", selectedModule);
                  setCsd(selectedModule[0]?.csd);
                  setMre(selectedModule[0]?.mre);
                  setLkd(selectedModule[0]?.lkd);
                  setPvr(selectedModule[0]?.pvr);
                  setPrn(selectedModule[0]?.prn);
                }
              })
              .catch((error) => {
                // console.log("getProductionDetailsForGetData error :-", error);
              });
            swal("Great", "Dispenser Serial Number Generated successfully...", "success");
            setIsProduction(true)
          } else {
            setisLoaded(false);
            swal("Failed", "Unknown Error Occurred", "error");
          }

          resetForm();
        } catch (error) {
          // console.log(error);
          setisLoaded(false);
          swal("Failed", "Failed to generate dispenser serial number", "error");
        }
      }}

    >
      {(formik) => {
        const { isValid, dirty, isSubmitting } = formik;
        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="production-list"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                  <h5 className="head mb-5 mt-2">Production Entry Form</h5>
                    <Form>
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Customer Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Customer Name"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Customer Name"
                                  title="Select Customer Name"
                                  options={customerName}
                                  // options={selectcustomer}
                               
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "customerName",
                                      e.value
                                    );
                                    setSelectedCustomer(e.id);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                           Production Wo No.
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Production Work order number"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="workOrderNo"
                                  placeholder="Enter Production Work order number"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="workOrderNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Product Type *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Product Type"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Product Type"
                                  options={selectProducttype}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "productType",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="productType"
                              component={TextError}
                            />
                          </div>
                        </Col>
                       
                      </Row>
                     
                      <button type="submit" disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || IsProduction} className="btn btn-primary mr-4">
                      <ToolTip
                      content="Generate dispenser Number"
                      direction="right"
                    >
                        Generate Dispenser Number{" "}
                      </ToolTip>
                      </button>
                      <div className="note">
                      <h4>Note :-</h4>
                        <h5>
                        Step 1 :- Conncet RS485 Cable to dispenser and scan dispenser data using production reading app
                        </h5>
                        <h5>
                          Step 2 :- login into production reading  app and start reading
                        </h5>
                        <h5>
                        Step 3 :-  After reading complete fill production form and generate disp number by clicking on generate dispenser number button
                        </h5>
                        <h5>
                          Step 4:- After generating dispenser number go to production reading  app and click on allocate sr no to dispenser button to allocate dispenser serial number to dispenser
                        </h5>

                      </div>
                      {/* Note :- After scan complete please click on acknowledgment button in native app.*/}

                      {/* ---------------------------------------------------------------- show dispenser data */}

                      <div className="main-form">
                        {show ? (
                          <Form>
                            <hr />
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    Model Name{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.modelName}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            {/* ---------------------------------------------------------------- Motherboard (MCU) */}
                            <h5
                              style={{ textAlign: "left", color: "darkblue" }}
                            >
                              Motherboard (MCU)
                            </h5>
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Firmware Version No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardSoftwareSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Hardware Version{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardHardwareVersion}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Serial No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">SHA2</label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardSHA2}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Sign X-509-64 Bit Block{" "}
                                  </label>
                                  <Field
                                     type="password"
                                    className="form-control"
                                    value={processData.mcuBoardSignXBitBlock}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Private Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardPrivateKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    RCA Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardRCAPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            {/* ---------------------------------------------------------------- Totalizer (TOT) */}
                            <h5
                              style={{ textAlign: "left", color: "darkblue" }}
                            >
                              Totalizer (TOT)
                            </h5>
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Firmware Version No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1SoftwareSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Hardware Version{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1HardwareVersion}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Serial No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1BoardSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">SHA2</label>
                                  <Field
                                 type="password"
                                    className="form-control"
                                    value={processData.memBoard1BoardSHA2}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Sign X-509-64 Bit Block{" "}
                                  </label>
                                  <Field
                                     type="password"
                                    className="form-control"
                                    value={processData.memBoard1SignXBitBlock}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1PublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Private Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1PrivateKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    RCA Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1RCAPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            {/* ---------------------------------------------------------------- Customer Display (CSD) */}
                            {csd.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Customer Display (CSD-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`csd${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                       type="password"
                                        className="form-control"
                                        value={
                                          processData[`csd${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                       type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {/* ---------------------------------------------------------------- Pulser (MRE) */}
                            {mre.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Pulser (MRE-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`mre${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                       type="password"
                                        className="form-control"
                                        value={
                                          processData[`mre${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {/* ---------------------------------------------------------------- Operator Keypad Display (LKD) */}
                            {lkd.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Operator Keypad Display (LKD-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`lkd${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                       type="password"
                                        className="form-control"
                                        value={
                                          processData[`lkd${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                         type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                              {/* ---------------------------------------------------------------- Vapor Recovery (VR) */}
                                {pvr.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                              Vapor Recovery (VR-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`pvr${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                      type="password"
                                        className="form-control"
                                        value={
                                          processData[`pvr${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                              {/* ---------------------------------------------------------------- Printer (Printer) */}
                                  {prn.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                    Printer (Printer-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`prn${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`prn${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                       type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </Form>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};
